import integrationRoutes from './integration.routes';

import integrationStatusComponent from './components/integration.status.component';
import integrationTableComponent from './components/integration.table.component';

import integrationStatusController from './controllers/integration.status.controller';
import integrationTableController from './controllers/integration.table.controller';

let integrationModule = angular.module('spabooker.integration', ['spabooker.base'])
    .config(integrationRoutes)

    .controller('integrationStatusController', integrationStatusController)
    .controller('integrationTableController', integrationTableController)

    .component('integrationStatus', integrationStatusComponent)
    .component('integrationTable', integrationTableComponent)
    ;

export default integrationModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/integration/index.js